import React from 'react';
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Tooltip, LabelList, Legend, CartesianGrid, Text } from 'recharts';
import { Colors } from '../../../constants/Colors.js';

const AvancesSICML = ({ isLocalidades, dataGraficaMunicipios, dataGraficaLocalidades, getAvanceLocalidades, setIsLocalidades }) => {
  const valueAccessor = attribute => ({ payload }) => {
    let value = payload[attribute];
    if (value > 0) {
      if (!isLocalidades) {
        if (value > 5) {
          return value;
        } else {
          return '';
        }
      } else {
        return value;
      }
    } else {
      return '';
    }
  };

  const handleBarClick = e => {
    let currentPayload = e.activePayload[0].payload;
    getAvanceLocalidades(currentPayload.id_municipio);
  };

  const CustomizedLabelB = ({ kapi, metric, viewBox }) => {
    return (
      <Text x={0} y={0} dx={-220} dy={40} textAnchor="start" width={400} transform="rotate(-90)">
        {'Nº de productores'}
      </Text>
    );
  };

  return (
    <>
      <ResponsiveContainer width="100%" height={460}>
        {/* header title and controls chart */}
        <div className="row">
          <div className="col-12">
            <h6 className="font-lato-normal-400 heading-box">Avances de levantamiento (SIC) por municipio y comunidad</h6>
            {!isLocalidades && (
              <a
                className="font-lato-normal-400"
                onClick={() => setIsLocalidades(false)}
                style={{
                  color: Colors.gray_base,
                  fontSize: 14,
                  textDecoration: 'none',
                }}>
                {'Selecciona un municipio para ver el avance de sus comunidades'}
              </a>
            )}
            {isLocalidades && (
              <a
                onClick={() => setIsLocalidades(false)}
                style={{ color: Colors.primary_500, fontSize: 14 }}
                className="float-right btn btn-link">
                {'<= Todos los municipios'}
              </a>
            )}
          </div>
        </div>
        <BarChart data={isLocalidades ? dataGraficaLocalidades : dataGraficaMunicipios} onClick={handleBarClick}>
          <CartesianGrid horizontal={false} vertical={false} strokeDasharray="3 3" />
          <XAxis
            angle={-45}
            textAnchor="end"
            height={120}
            padding={{ top: 80, left: 15, right: 15 }}
            dataKey={isLocalidades ? 'localidad' : 'municipio'}
          />
          <YAxis tick={false} label={<CustomizedLabelB />} />
          <Tooltip />
          <Legend />
          <Bar
            legendType={'none'}
            name="Realizado"
            radius={5}
            barSize={150}
            dataKey="total_levantado"
            stackId="a"
            fill={isLocalidades ? '#4A6700' : '#C7AE34'}>
            <LabelList
              position={'insideBottom'}
              style={{
                textAnchor: 'middle',
                fontSize: '14',
                fill: Colors.white,
              }}
              valueAccessor={valueAccessor('total_levantado')}
            />
          </Bar>
          <Bar
            legendType={'none'}
            name="Pendiente"
            radius={5}
            barSize={150}
            dataKey="total_pendiente"
            stackId="a"
            fill={isLocalidades ? Colors.black_medium : Colors.black_medium}>
            <LabelList
              position={'insideTop'}
              style={{
                textAnchor: 'middle',
                fontSize: '14',
                fill: Colors.neutral_2,
              }}
              valueAccessor={valueAccessor('total_pendiente')}
            />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </>
  );
};

export default AvancesSICML;
